import { Box } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export default function RedirectMessageModal({ label, operatorName }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "0 32px 32px 32px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          boxShadow:
            "0 8px 16px -16px rgba(41, 45, 50, 0.24), 0 32px 80px 0 rgba(41, 45, 50, 0.12)",
          backgroundColor:
            "var(--color-surface-alerts-status-info-tint, #CCEDF9)",
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            padding: "var(--spacing-md)",
          }}
        >
          <InfoIcon width={22} height={22} sx={{ color: "#00A7E1" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flex: "1",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "var(--spacing-md)",
            gap: "var(--spacing-xs)",
            fontFamily: "var(--caption-font-family)",
          }}
        >
          <Box
            sx={{
              fontWeight: 700,
              color: "var(--color-text-primary)",
              fontSize: "17px",
            }}
          >
            Redirecting
          </Box>
          <Box
            sx={{
              fontWeight: 400,
              color: "var(--color-text-secondary)",
              fontSize: "14px",
            }}
          >
            {label}{" "}
            <span
              style={{
                fontWeight: 700,
                color: "var(--color-text-secondary)",
                fontSize: "14px",
              }}
            >
              {operatorName}
            </span>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
